import React from 'react';
import GoogleAnalytics from './GoogleAnalytics';
import FacebookPixel from './FacebookPixel';

interface AnalyticsConfigProps {
  googleAnalyticsId?: string;
  facebookPixelId?: string;
}

const AnalyticsConfig: React.FC<AnalyticsConfigProps> = ({
  googleAnalyticsId = 'YOUR_GA4_MEASUREMENT_ID',
  facebookPixelId = 'YOUR_FACEBOOK_PIXEL_ID'
}) => {
  return (
    <>
      {googleAnalyticsId && googleAnalyticsId !== 'YOUR_GA4_MEASUREMENT_ID' && (
        <GoogleAnalytics measurementId={googleAnalyticsId} />
      )}
      {facebookPixelId && facebookPixelId !== 'YOUR_FACEBOOK_PIXEL_ID' && (
        <FacebookPixel pixelId={facebookPixelId} />
      )}
    </>
  );
};

export default AnalyticsConfig;